module.exports = __webpack_public_path__ + "8cc2b4efa63c480d643a894537d4d3ff.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/users-shared-accounts/users-shared-notes.html
// module id = 2592
// module chunks = 0